import React, { useCallback, useEffect } from 'react';

import { FormGroup, ControlLabel } from 'react-bootstrap';
import styled from 'styled-components';

import RadioButtons from '../../utils/FormWidgets/RadioButtons';
import { BookingOption, Location, LocationType } from '../../../types/Activity';
import ActivityLocationField, {
  LocationFileds,
} from '../ActivityMetaFields/ActivityLocationField/ActivityLocationField';

type Props = {
  bookingOption: Partial<BookingOption>;
  onChange(fields: Partial<BookingOption>): void;
};

const StyledRadioButtonsWrapper = styled(FormGroup)`
  .radio {
    margin-right: 10px;
  }
`;

const BookingOptionLocation = ({ bookingOption, onChange }: Props) => {
  const { subType, locationType, location } = bookingOption ?? {
    subType: undefined,
    location: undefined,
    locationType: undefined,
  };
  const isAddonSubtype = subType === 'addon';

  const isShownLocation =
    locationType &&
    locationType === LocationType.vendorLocation &&
    !isAddonSubtype;

  const onLocationChange = (items: LocationFileds[]) => {
    const item = items[0];
    const { value } = item;
    onChange({ ...bookingOption, location: (value as unknown) as Location });
  };

  const onClearLocation = useCallback(() => {
    const clearAll = () => {
      onChange({
        ...bookingOption,
        location: undefined,
        locationType: undefined,
      });
    };

    if (locationType === LocationType.atHome) {
      onChange({ ...bookingOption, location: undefined });
    }
    if (isAddonSubtype) {
      clearAll();
    }
  }, [isAddonSubtype, locationType]);

  useEffect(() => {
    onClearLocation();
  }, [onClearLocation]);

  return (
    <>
      {!isAddonSubtype && (
        <StyledRadioButtonsWrapper>
          <ControlLabel>Location Type*</ControlLabel>
          <RadioButtons
            name='locationType'
            value={locationType as string}
            label='Location Type'
            onRadioChange={(_, val) =>
              onChange({
                ...bookingOption,
                locationType: val as keyof typeof LocationType,
              })
            }
            options={[
              {
                label: 'At-home',
                value: LocationType.atHome,
              },
              {
                label: 'Vendor Location',
                value: LocationType.vendorLocation,
              },
            ]}
          />
        </StyledRadioButtonsWrapper>
      )}
      {isShownLocation && (
        <ActivityLocationField
          location={location}
          onMetaFieldsChange={onLocationChange}
          display='block'
          isMobileView={false}
          isMobileEditMode={false}
        />
      )}
    </>
  );
};

export default BookingOptionLocation;
